import { Box, Text } from 'grommet';
import { HerdItem } from './HerdItem';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../redux';

// TODO grazing is disabled
export const HerdStep = () => {
  const { t } = useTranslation();

  const fields = useAppSelector((state) => state.map.fields);
  const paddocks = useAppSelector((state) => state.map.paddocks ?? {});
  const state = useAppSelector((state) => state.map.state);
  const herds = useAppSelector((state) => state.map.herds);

  const addHerd = () => {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const updateHerdData = (_: any) => {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const updateHerd = (_: any) => {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const removeHerd = (_: any) => {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const duplicateHerd = (_: any) => {};
  const getLastChangeDate = () => new Promise<{ lastDate: Date }>((resolve) => resolve({ lastDate: new Date() }));
  const currentVersion = { name: '', startDate: new Date() };

  //Reset position of herds inside modified paddocks
  useEffect(() => {
    const herdsWithoutPaddock = herds.map((herd) => {
      if (herd.fieldId === 'OFFSITE') {
        herd.fieldName = 'OFFSITE';
        herd.paddockId = 'OFFSITE';
        herd.paddockName = 'OFFSITE';
        return herd;
      }
      if (herd.fieldId && paddocks[herd.fieldId].length === 1) {
        herd.fieldName = fields.find((field) => field.id === herd.fieldId)?.properties?.name;
        herd.paddockId = paddocks[herd.fieldId][0].id?.toString() ?? undefined;
        herd.paddockName = paddocks[herd.fieldId][0].properties?.name?.toString() ?? undefined;
        return herd;
      }
      if (herd.fieldId && !paddocks[herd.fieldId].some((element) => element.id === herd.paddockId)) {
        herd.fieldName = fields.find((field) => field.id === herd.fieldId)?.properties?.name;
        herd.paddockId = undefined;
        herd.paddockName = undefined;
        return herd;
      }
      return herd;
    });
    updateHerdData([...herdsWithoutPaddock]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box margin={'24px'} gap={'16px'} overflow={'auto'}>
      {herds.map((herd, index) => (
        <HerdItem
          key={index}
          state={state}
          herd={herd}
          duplicateHerd={duplicateHerd}
          updateHerd={updateHerd}
          removeHerd={removeHerd}
          fields={fields}
          paddocks={paddocks}
          currentVersion={currentVersion}
          getLastChangeDate={getLastChangeDate}
        />
      ))}
      <Box
        onClick={() => addHerd()}
        height={{ min: '84px' }}
        align={'center'}
        justify={'center'}
        border={{ size: '1px', color: '#CCCCCC' }}
        style={{
          borderRadius: '5px',
          cursor: 'pointer',
        }}>
        <Text size={'16px'} style={{ lineHeight: '20px' }} color={'#282828'} weight={400}>
          {t('fieldFlow.mainWizard.Herds.create')}
        </Text>
      </Box>
    </Box>
  );
};
